require('../styles/sass/main.scss');

riot.tag2('dealer-locator-container', '<yield></yield>', '', 'class="acr-dl-main {opts.theme} {\'is-detail\': dealer,   \'is-filter\': filter,   \'no-filters\': opts.disableFilters === \'true\',   \'is-embedded-in-raq\': (opts.dataIsEmbeddedInRaq || false) && (opts.dataIsEmbeddedInRaq.toLowerCase() === \'true\'),   \'map-on-left\': opts.mapOnLeft === \'true\'}"', function(opts) {
    var DealerService = require('../core/DealerService.js');
    var filterService = require('../core/Filters.js');
    var floodlight = require('../core/Floodlight');
    var constants = require('../core/constants.js');
    var urlSetter = require('../core/UrlSetter.js');
    var trackingJSON = require('../data/tracking-data');
    var mapConstants = constants.map;
    var self = this;
    var divisionCode = self.opts.divisionCode ? self.opts.divisionCode : 'A';
    var additionalsRequestParameters = self.labels.additionalsRequestParameters || '';
    var serviceURL = constants.global.ENDPOINT
    + divisionCode
    + additionalsRequestParameters;
    var service;
    var qsFiltersString = self.url.findParameter('filters');
    var qsFilters;
    var trackingTriggered = false;
    var vehicleModelSeries = self.url.findParameter('vehiclemodelseries') ? self.url.findParameter('vehiclemodelseries').toLowerCase() : undefined;
    var year = self.url.findParameter('modelYear') ? self.url.findParameter('modelYear').toLowerCase() : undefined;
    var reserveOnlineHeaderDescriptionLabelName = (vehicleModelSeries && year) ? `reserveOnlineHeaderDescription${vehicleModelSeries.toUpperCase()}${year}` : '';
    var reserveOnlineHeaderDescription = self.labels[reserveOnlineHeaderDescriptionLabelName] ? self.labels[reserveOnlineHeaderDescriptionLabelName] : undefined;
    var tabsWithoutDistance = ['tab-3']; // filter tabs without distance by tabId
    // variable to modify behaviors when DL is embedded on RAQ (PLEASE USE CAREFULLY)
    window.dealerLocator = window.dealerLocator || {};
    var isEmbeddedInRaq = (self.opts.dataIsEmbeddedInRaq || false)
                                            && (self.opts.dataIsEmbeddedInRaq.toLowerCase() === 'true');
    window.dealerLocator.isStartReservation = false;

    if (qsFiltersString
    && qsFiltersString.indexOf(constants.global.START_RESERVATION_FILTER_CODE) > -1
    && reserveOnlineHeaderDescription) {
      window.dealerLocator.isStartReservation = true;
      qsFiltersString = qsFiltersString.replace(constants.global.START_RESERVATION_FILTER_CODE, '');
      window.dealerLocator.modelName = vehicleModelSeries;
      window.dealerLocator.modelYear = year;
    }
    self.isStartReservation = window.dealerLocator.isStartReservation;
    self.headerDescription = window.dealerLocator.isStartReservation ? reserveOnlineHeaderDescription : self.labels.headerDescription;
    if (process.env.NODE_ENV !== 'production') {
      serviceURL = constants.dev.BASE_URL + serviceURL;
    }
    service = new DealerService(serviceURL);

    this.mixin('bus');
    this.mixin('cookie');

    self.maxDealers = isEmbeddedInRaq ? 3 : 5;
    self.dealerNameCookieLabel = 'dealername';
    self.cookieZip = self.cookie.get(self.labels.zipCodeCookie);
    self.cookiePreferred = self.cookie.get(self.labels.preferredCookie);
    self.DealerName = self.cookie.get(self.dealerNameCookieLabel);
    self.hasZipCode = false;
    self.showSpinner = true;
    self.trackingDataBodyShop = JSON.stringify(trackingJSON.locateBodyShop);

    self.dealer = false;
    self.filter = false;
    self.filterDistance = false;
    self.dealers = [];
    self.dealersBase = [];
    self.DealerNumber = (self.cookiePreferred) ? self.cookiePreferred : false;
    self.DealerName = (self.DealerName) ? self.DealerName : false;
    self.dirty = false;
    self.preferredDealer = false;
    self.showDistance = true;
    self.isUrlSetted = false;
    self.geolocationAllowed = false;
    self.modalRAQ = document.querySelector('.modal-raq')
                    || document.querySelector('bap-content-modal')
                    || document.querySelector('offers-modal-wrapper');

    function focusLocator() {
      var $locator = self.root;
      var $acrNav = document.querySelector('.acr-nav');
      var offset = $acrNav ? $acrNav.offsetHeight : 0;

      if (isEmbeddedInRaq) {
        document.querySelector('.raq-content').scrollIntoView();
        if (!self.modalRAQ) {
          window.scrollBy(0, -(offset));
        }
      } else {
        window.scrollTo($locator.offsetTop, 0);
      }
    }

    function checkFloodlights(results) {
      var filtersApplied = filterService.get().applied.length > 0 && filterService.get().distance;
      if (results.length > 0 && self.labels.floodlightUrl
          && self.labels.floodlightUrl !== '' && !filtersApplied) {
        floodlight.init(self.labels.floodlightUrl);
      }
    }

    function showGeolocationError() {
      self.dealers = [];
      self.noGeolocation = true;
      self.update();
    }

    function scroll(event) {
      var searchContainer = self.root.querySelector('.search-container');
      var dealersContainer = self.root.querySelector('.dealer-results-container');
      var mapContainer = self.root.querySelector('.map-container');
      var acrNav = document.querySelector('.acr-nav');
      var mapContainerHeight = mapContainer ? mapContainer.clientHeight : 0;
      var navContainerHeight = acrNav ? acrNav.clientHeight : 0;
      var h = Math.max(document.documentElement.clientHeight + 15, window.innerHeight + 15 || 0);
      var searchContainerPos;
      var dealersContainerPos;

      if (searchContainer && mapContainer && dealersContainer) {
        searchContainerPos = searchContainer.getBoundingClientRect();
        dealersContainerPos = dealersContainer.getBoundingClientRect();
        dealersContainerPos = dealersContainer.getBoundingClientRect();

        if (event) {
          event.stopPropagation();
        }

        if (dealersContainerPos.height > mapContainerHeight) {
          if (window.innerWidth >= mapConstants.MOBILE_BREAKPOINT && !self.dealer) {
            if (searchContainerPos.top <= navContainerHeight) {
              mapContainer.classList.add('fixed');
            } else if (mapContainer.classList.contains('fixed')) {
              mapContainer.classList.remove('fixed');
            }

            if (dealersContainerPos.bottom <= h) {
              mapContainer.classList.add('fixed-bottom');
            } else if (mapContainer.classList.contains('fixed-bottom')) {
              mapContainer.classList.remove('fixed-bottom');
            }
          }
        } else {
          mapContainer.classList.remove('fixed');
          mapContainer.classList.remove('fixed-bottom');
        }
      }
    }

    function scrollRAQ() {
      var searchContainer = self.root.querySelector('.search-container');
      var dealersContainer = self.root.querySelector('.dealer-results-container');
      var mapContainer = self.root.querySelector('.map-container');
      var h = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
      var searchContainerPos;
      var dealersContainerPos;

      if (searchContainer && mapContainer && dealersContainer) {
        searchContainerPos = searchContainer.getBoundingClientRect();
        dealersContainerPos = dealersContainer.getBoundingClientRect();

        if (window.innerWidth >= mapConstants.MOBILE_BREAKPOINT && !self.dealer) {
          if (searchContainerPos.top <= 0) {
            mapContainer.classList.add('fixed');
            mapContainer.style.top = self.modalRAQ.scrollTop - 35 + 'px';
          } else if (mapContainer.classList.contains('fixed')) {
            mapContainer.classList.remove('fixed');
            mapContainer.style.top = '0px';
          }

          if (dealersContainerPos.bottom - 5 <= h) {
            mapContainer.classList.add('fixed-bottom');
            mapContainer.style.top = 'auto';
          } else if (mapContainer.classList.contains('fixed-bottom')) {
            mapContainer.classList.remove('fixed-bottom');
          }
        }
      }
    }

    function getAttributeCode(attribute) {
      filterService.addDealersAttribute(attribute.Code);
    }

    function mapDealers(currentDealer) {
      var dealer = currentDealer;

      if (dealer.DealerNumber === self.DealerNumber) {
        dealer.preferred = true;
        self.preferredDealer = dealer;
      } else {
        dealer.preferred = false;
      }

      dealer.Attributes.map(getAttributeCode);

      return dealer;
    }

    function applyFilters(dealersArray) {
      var dealers;

      dealers = filterService.filter(dealersArray, self.filterDistance);

      self.bus.trigger(self.bus.EVENTS.FILTERS.SELECTED, { filters: filterService.get() });

      return dealers;
    }

    function generateDealers(dealersArray) {
      var dealers;
      var i;
      var arrayLength;
      filterService.resetDealersAttributes();
      dealers = dealersArray.map(mapDealers);
      arrayLength = dealers.length;

      for (i = 0; i < arrayLength; i++) {
        if (dealers[i].preferred === true) {
          dealers.splice(i, 1);
          break;
        }
      }

      dealers = applyFilters(dealers);

      if (self.preferredDealer) {
        dealers.unshift(self.preferredDealer);
      }

      return dealers;
    }

    function triggerTrackingPageload() {
      if (window.Acr && window.Acr.TrackingManager) {
        window.Acr.TrackingManager.pageLoad(window.Acr.trackingObject);
      } else {
      // this event will be triggered once that
      // TrackingManager.js is loaded. Used to avoid dependencies issues.
        window.addEventListener('trackingPageload', function runPageLoad() {
          window.Acr.TrackingManager.pageLoad(window.Acr.trackingObject);
        });
      }
    }

    function searchDealers(data) {
      self.noGeolocation = false;
      self.hasZipCode = true;
      self.showSpinner = true;
      self.update();

      self.bus.trigger(self.bus.EVENTS.DEALERS.RESET_ORIGIN);
      if (window.dealerLocator.isStartReservation) {
        data.filters = constants.global.START_RESERVATION_FILTER_CODE;
      }
      if (data.city || data.zip) {
        self.bus.trigger(self.bus.EVENTS.DEALERS.SET_ORIGIN, data);
      }

      service.fetchDealers(data).then(function responseHandler(response) {
        self.dealersBase = (response.Dealers !== null) ? response.Dealers : [];
        self.dealers = generateDealers(self.dealersBase);
        self.dirty = true;
        self.update();

        self.bus.trigger(self.bus.EVENTS.DEALERS.DATA_LOADED, {
          points: self.dealers.slice(0, self.maxDealers),
          total: self.dealersBase.length,
        });

        self.bus.trigger(self.bus.EVENTS.DEALERS.UPDATE_ZIPCODE, {
          zipcode: response.ZipCode,
        });
        if (!trackingTriggered && !isEmbeddedInRaq) {
          trackingTriggered = true;
          triggerTrackingPageload();
        }
        checkFloodlights(self.dealers);
      }).catch(function errorHandler(err) {
        window.console.warn('Search Dealer Error:', err);
        self.update();
        if (data.lat && data.long) {
          showGeolocationError();
        }
      });
    }

    function setPreferred(data) {
      var dlOffset = self.root.offsetTop;

      self.DealerNumber = data.DealerNumber;
      self.DealerName = data.DealerName;

      self.cookie.set(self.labels.preferredCookie, self.DealerNumber,
        {
          path: '/',
        });
      self.cookie.set(self.dealerNameCookieLabel, self.DealerName,
        {
          path: '/',
        });

      window.scrollTo(0, dlOffset);

      self.dealers = generateDealers(self.dealersBase);

      self.bus.trigger(self.bus.EVENTS.DEALERS.LIST_UPDATED, {
        points: self.dealers,
        total: self.dealersBase.length,
      });
    }

    function resetDealers(dealer) {
      var temp = dealer;

      temp.preferred = false;

      return temp;
    }

    function unsetPreferred() {
      self.DealerName = false;
      self.DealerNumber = false;
      self.preferredDealer = false;
      self.dealers = generateDealers(self.dealersBase.filter(resetDealers));
      self.cookie.set(self.labels.preferredCookie, '', { maxAge: -1, path: '/' });
      self.cookie.set(self.dealerNameCookieLabel, '', { maxAge: -1, path: '/' });

      self.bus.trigger(self.bus.EVENTS.DEALERS.LIST_UPDATED, {
        points: self.dealers,
        total: self.dealersBase.length,
      });
    }

    function selectDealer(data) {
      var i;

      for (i = 0; i < self.dealers.length; i++) {
        if (i === data.index) {
          self.dealers[i].selected = true;
        } else {
          self.dealers[i].selected = false;
        }
      }

      self.update();
    }

    function openDetail(data) {
      var originalDealer;

      self.dealer = self.dealers[data.index];
      originalDealer = self.dealers.filter(function searchDealerById(dealer, index) {
        var tempDealer = dealer;
        tempDealer.index = index;
        return tempDealer.DealerNumber === self.dealer.DealerNumber;
      })[0];

      self.dealer.index = (originalDealer) ? originalDealer.index + 1 : 1;

      focusLocator();

      self.update();
    }

    function closeDetail() {
      self.dealer = false;

      self.bus.trigger(self.bus.EVENTS.DEALERS.CLOSE_DETAIL);

      self.update();
    }

    function getInitialPreferred() {
      service.fetchDealers({ number: self.DealerNumber }).then(
        function responseHandler(response) {
          if (response && response.DealerNumber) {
            self.preferredDealer = response;
            self.preferredDealer.preferred = true;
            self.dealers.push(self.preferredDealer);

            self.update();
          }
        }
      ).catch(function errorHandler(err) {
        window.console.warn('Search Dealer Error:', err);
      });
    }

    function closeFilter() {
      self.filter = false;

      filterService.cleanSelectedFilters();

      self.update();
    }

    function checkFilter(data) {
      if (tabsWithoutDistance.indexOf(data.id) !== -1) {
        self.showDistance = false;
      } else {
        self.showDistance = true;
      }

      self.tags['dealer-filters'].update();
    }

    function filterDealers(opts) {
      self.filterDistance = opts.distance && opts.distance !== '--'
        ? opts.distance
        : false;
      self.filter = false;
      self.dealers = generateDealers(self.dealersBase);

      self.bus.trigger(self.bus.EVENTS.DEALERS.LIST_UPDATED, {
        points: self.dealers,
        total: self.dealersBase.length,
      });

      focusLocator();

      self.update();
    }

    function triggerSearch(zipCode) {
      self.bus.trigger(self.bus.EVENTS.DEALERS.SEARCH, {
        zip: zipCode,
        maxResults: parseInt(self.labels.zipCodeMaxResults, 10) || Infinity,
      });
      self.update();
    }

    function allowGeolocation() {
      self.geolocationAllowed = true;
    }

    function zipcodeEvent(event) {
      var zipcodeAvailable = event.detail && event.detail.zipcode;
      var data;

      if (zipcodeAvailable) {
        data = {
          zip: event.detail.zipcode,
          maxResults: 16,
        };

        self.closeDetail();
        if (!isEmbeddedInRaq) {
          window.Utility.setCookie('zipcode', data.zip);
          self.url.updateZipcodeQuery(data.zip);
        }

        if (window.dl.mapLoaded) {
          self.bus.trigger(self.bus.EVENTS.DEALERS.SEARCH, data);
        }
      }
    }

    function hideSpinner() {
      self.showSpinner = false;

      // Let the map to complete the paint of itself
      setTimeout(function delayUpdate() {
        self.update();
      }, 500);
    }

    function validateScroll() {
      if (self.modalRAQ) {
        scrollRAQ();
      } else {
        scroll();
      }
    }

    function initDealers() {
      if (self.cookie.get(self.labels.zipCodeCookie)) {
        triggerSearch(self.cookie.get(self.labels.zipCodeCookie));
      } else {
        hideSpinner();
      }
    }

    this.bus.on(this.bus.EVENTS.DEALERS.SEARCH, searchDealers);
    this.bus.on(this.bus.EVENTS.DEALERS.SET_PREFERRED, setPreferred);
    this.bus.on(this.bus.EVENTS.DEALERS.UNSET_PREFERRED, unsetPreferred);
    this.bus.on(this.bus.EVENTS.DEALERS.SELECT, selectDealer);
    this.bus.on(this.bus.EVENTS.DEALERS.CLOSE_FILTER, closeFilter);
    this.bus.on(this.bus.EVENTS.DEALERS.OPEN_DETAIL, openDetail);
    this.bus.on(this.bus.EVENTS.ERRORS.GEOLOCATION, showGeolocationError);
    this.bus.on(this.bus.EVENTS.GEOLOCATION.ALLOWED, allowGeolocation);
    this.bus.on(this.bus.EVENTS.TABS.SELECT, checkFilter);
    this.bus.on(this.bus.EVENTS.FILTERS.SELECT, filterService.select);
    this.bus.on(this.bus.EVENTS.FILTERS.UNSELECT, filterService.unselect);
    this.bus.on(this.bus.EVENTS.FILTERS.APPLY, filterDealers);
    this.bus.on(this.bus.EVENTS.LOCATOR.FOCUS, focusLocator);
    this.bus.on(this.bus.EVENTS.MAP.RESIZE, validateScroll);
    this.bus.on(this.bus.EVENTS.MAP.READY, hideSpinner);

    self.closeDetail = closeDetail;

    this.on('mount', function mount() {
      self.modalRAQ = document.querySelector('.modal-raq')
                      || document.querySelector('bap-content-modal')
                      || document.querySelector('ui-modal');

      self.offersRAQ = document.querySelector('offers-modal-wrapper');
      window.addEventListener('zipcodeUpdate', zipcodeEvent);
      window.addEventListener('dealerSearch', zipcodeEvent);

      if (self.modalRAQ) {
        self.modalRAQ.addEventListener('scroll', scrollRAQ);
      } else {
        window.addEventListener('scroll', scroll);
      }

      if (document.getElementsByClassName('dynamic-url').length) {
        urlSetter.init();
        self.isUrlSetted = true;
      }

      if (self.DealerNumber) {
        getInitialPreferred();
      }

      if (window.dl.mapLoaded) {
        initDealers();
      }

      if (qsFiltersString) {
        qsFilters = qsFiltersString.toLowerCase().split(',');

        self.filters.forEach(function iterateSections(filterSection) {
          var selectedFilters = filterSection.items.filter(function filterItems(filter) {
            var currentFilter = filter;
            // Map filter codes to include the always shown
            currentFilter.codes.map(function mapCodes(code) {
              var currentCode = code;
              currentCode.alwaysShown = currentFilter.alwaysShown;
              return currentCode;
            });
            return currentFilter.codes.reduce(function reduceCodes(value, codeItem) {
              return value || qsFilters.indexOf(codeItem.code.toLowerCase()) > -1;
            }, false);
          });

          selectedFilters.forEach(function iterateSelectedFilters(selectedFilter) {
            filterService.select(selectedFilter);
          });
        });
      }
    });

    window.addEventListener('bingmapsloaded', function bingMapLoaded() {
      initDealers();

      window.dl.mapLoaded = true;
    });

    this.on('update', function update() {
      if (!self.isUrlSetted && document.getElementsByClassName('dynamic-url').length) {
        urlSetter.init();
        self.isUrlSetted = true;
      }
    });

});
